import { jsx } from "react/jsx-runtime";
import Card from "antd/es/card/Card";
import classnames from "../../utils/classnames.js";
import FinanceProgramImage from "./FinanceProgramImage.js";
import FinanceProgramPrice from "./FinanceProgramPrice.js";
import FinanceProgramTable from "./FinanceProgramTable.js";
import ProgramTitle from "./FinanceProgramTitle.js";
import './FinanceProgram.css';/* empty css                    */
const FinanceProgram = ({ children, className, logo, isSelected, ...props }) => {
  return /* @__PURE__ */ jsx(
    Card,
    {
      hoverable: true,
      className: classnames(
        [
          "perxis-auto-finance-program",
          {
            [`perxis-auto-finance-program--selected`]: !!isSelected,
            [`perxis-auto-finance-program--with-logo`]: !!logo
          }
        ],
        className
      ),
      ...props,
      children
    }
  );
};
FinanceProgram.Image = FinanceProgramImage;
FinanceProgram.Table = FinanceProgramTable;
FinanceProgram.Title = ProgramTitle;
FinanceProgram.Price = FinanceProgramPrice;
export {
  FinanceProgram as default
};
//# sourceMappingURL=FinanceProgram.js.map
